import React from "react";
import clsx from "clsx";

interface ReservationButtonInnerProps {
    children?: React.ReactNode | React.ReactNode[];
    className?: string;
}

const ReservationButtonInner = (props: ReservationButtonInnerProps) => {
    return (
        <div
            className={clsx(
                "ReservationButtonInner border border-arbo-red font-bold text-sm md:text-xl rounded-[10px] flex flex-row items-center justify-center gap-x-2.5 py-[10px] px-3 w-full",
                props.className
            )}
        >
            {props.children && props.children}
        </div>
    );
};

export default ReservationButtonInner;
